import { useDispatch } from 'react-redux';

import { SNACKBAR_SKIN } from 'components/shared/Snackbar';
import { showSnackbar } from 'hooks/useSnackbar';
import useValidationSchema from 'hooks/useValidationSchema';
import { addFontThunk } from 'store/fonts/thunks';

import validationSchema from './validationSchema';

export function useFontsForm({ getFonts, handleCloseFontsForm }) {
  const dispatch = useDispatch();
  const validate = useValidationSchema(validationSchema);
  const acceptFonts = ['.woff', '.woff2', '.otf', '.ttf', '.eot', '.svg'];

  const submit = async (values) => {
    try {
      const fontFileName = values?.file?.name || '';
      await dispatch(addFontThunk(values));
      await getFonts();
      handleCloseFontsForm();
      showSnackbar({ text: `Font ${fontFileName} uploaded successfully` });
    } catch (err) {
      showSnackbar({ text: 'Oops! Something went wrong', type: SNACKBAR_SKIN.ERROR });
    }
  };

  return {
    validate,
    submit,
    acceptFonts,
  };
}
